import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getPassengerToken } from "../../passengerAuth";

export default function PassengerProtectedRoute() {
  const token = getPassengerToken();
  if (!token) {
    return <Navigate to="/passenger/login" replace />;
  }
  return <Outlet />;
}
